<div class="flex items-center justify-center">
  <div>En ny oppdatering av Jatakk er tilgjengelig</div>
  <div>
    <button mat-button color="accent" (click)="update()">Oppdater nå</button>
  </div>
  <div>
    <button mat-icon-button color="accent" (click)="cancel()">
      <mat-icon>close</mat-icon>
    </button>
  </div>
</div>
